import * as React from 'react';

// Constants
import { Layout, DESKTOP_MEDIA_QUERY } from '../constants';

export default function useResponsiveLayout() {
  const [isDesktop, setIsDesktop] = React.useState<boolean>(false); // mobile first

  React.useLayoutEffect(() => {
    const desktopMediaWatcher = window.matchMedia(DESKTOP_MEDIA_QUERY);
    setIsDesktop(desktopMediaWatcher.matches);

    function updateDesktopMediaWatcher(event: MediaQueryListEvent) {
      setIsDesktop(event.matches);
    }

    if (desktopMediaWatcher.addEventListener) {
      desktopMediaWatcher.addEventListener('change', updateDesktopMediaWatcher);
      return () => {
        desktopMediaWatcher.removeEventListener(
          'change',
          updateDesktopMediaWatcher
        );
      };
    } else {
      // backwards compatibility
      desktopMediaWatcher.addListener(updateDesktopMediaWatcher);
      return () => {
        desktopMediaWatcher.removeListener(updateDesktopMediaWatcher);
      };
    }
  }, []);

  return {
    layout: isDesktop ? Layout.Desktop : Layout.Mobile,
  };
}
